import { CircularProgress } from "@mui/material";
import styles from "./PageLoader.module.scss";
import { useTranslation } from "../../i18n";

interface PageLoaderProps {
  label?: string;
}

export const PageLoader = ({ label }: PageLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <CircularProgress color="primary" size={48} thickness={4} />
      <span className={styles.label}>{label ?? t("loader.loading")}</span>
    </div>
  );
};
